export class EmbeddedViewService {
	static $inject = ['mx.shell.LeftSidebarService', 'mx.shell.ToolbarManager', 'mx.shell.SideLayout', 'mx.shell.Config'];

	constructor(leftSidebarService, toolbarManager, sideLayout, config) {
		Object.assign(this, { leftSidebarService, toolbarManager, sideLayout, config });
	}

	activate() {
		const { leftSidebarService, toolbarManager, sideLayout, config } = this;
		$('body').addClass('mx-embedded-view');
		sideLayout.fullScreenMode = true;

		toolbarManager.isVisible = false;
		leftSidebarService.isVisible = false;
		sideLayout.switchFullScreenMode();

		mx.EmbeddedView = mx.EmbeddedView || {};
		mx.EmbeddedView.save = function () {
			$($('.mx-action-generic--done, .mx-wizard-button--next button, .mx-wizard-button--finish button').get(0)).click();
			var checkInterval = window.setInterval(function () {
				var id = $('mx-side-panel [external-usage-output--object-id]:visible').attr('external-usage-output--object-id');
				if (id) {
					window.clearInterval(checkInterval);
					window.location.href =
						window.location.origin +
						config.settings.basePath +
						'guid-output.html' +
						//This JSON is needed for Native Mobile team, because iPhone App gets ID from URL.
						// But it may change after they release.
						// Proper way is to get ID from HTML body by this URL.
						// In this case we can just remove next line.
						'?view-options=' +
						JSON.stringify({ embedded: true, createdObjectId: id }) +
						// This line is mandatory.
						'#' +
						id;
				}
			}, 500);
			window.setTimeout(function () {
				if (checkInterval) {
					window.clearInterval(checkInterval);
				}
			}, 3 * 60 * 1000);
		};
	}
}
